<template>
  <md-list-item class="change-uplatainsha" @click="isFormOpened = !isFormOpened">

    <span class="md-list-item-text">{{i18n.set_change_xpay() }}</span>
    <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>

    <md-dialog class="change-password__dialog" :md-active.sync="isFormOpened" :md-click-outside-to-close="!isPending">
      <md-progress-bar md-mode="indeterminate" v-if="isPending"/>
      <md-dialog-title>{{ i18n.set_change_xpay() }}</md-dialog-title>
      <form novalidate
            class="change-uplatainsha"
            @submit.prevent="submit">
        <template v-if="isDisabled">
          <div class="container">
            <p>{{i18n.lbl_no_xpay()}}</p>
          </div>
        </template>
        <div class="app__dialog-inner">
          <div v-if="form.idx !== -1" class="label-select__actions">
            <label class="label-select__caption">{{ i18n.lbl_auto_withdraw() }}</label>
            <label class="label-select__caption">{{ i18n.lbl_card_delete() }}</label>
          </div>
          <md-field>
            <md-select name="uplatainsha" v-model="form.idx" :label="i18n.lbl_xpay()">
              <template v-if="xpayUpdated.length === 0">
                <md-option :value="-2" :key="-2">
                  {{ i18n.lbl_no_card() }}
                </md-option>
              </template>
              <md-option :value="-1" :key="-1">
                {{ i18n.lbl_card_add() }}
              </md-option>
              <md-option v-for="(val, i) in xpayUpdated" :value="i" :selected="i === form.idx" :key="i">
                {{val.id}}
              </md-option>
            </md-select>
            <!-- event call temporarily deleted @click="onAutoWithdraw" -->
            <div v-if="(form.idx !== -1) && (form.idx !== -2)" class="auto-withdraw">
              <md-icon v-if="xpayUpdated[form.idx].auto"
                       :class="'select-icon-size flex-end__item'">check_box</md-icon>
              <md-icon v-else
                       class="select-icon-size flex-end__item">crop_3_2</md-icon>
            </div>
            <!-- event call temporarily deleted @click="onDelete" -->
            <div v-if="(form.idx !== -1) && (form.idx !== -2)" class="delete-uplata right-align__item">
              <md-icon class="select-icon-size">delete</md-icon>
            </div>
          </md-field>
        </div>
        <md-dialog-actions class="md-layout md-alignment-center-right">
          <md-button type="button" class="md-primary" :disabled="isPending" @click="isFormOpened = !isFormOpened">{{ i18n.lbl_close() }}</md-button>
        </md-dialog-actions>
      </form>
    </md-dialog>
  </md-list-item>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import { mapGetters, mapActions } from 'vuex'
import { EventDispatcher } from '@js/events/event_dispatcher'
import { vuexTypes } from '@vuex/types'
import { i18n } from '@js/i18n'
import Form from '@com/mixins/form.mixin'
import { confirmAction } from '@js/modals/confirmation_message'
import { XPAY_NON_VISIBLE_TYPE } from '@const'

export default {
  name: 'change-uplatainsha',
  mixins: [Form],
  components: { TheMask },
  data: _ => ({
    isFormOpened: false,
    isDisabled: false,
    isReadyToAdd: false,
    isUpdated: false,
    i18n,
    form: {
      idx: -2,
      newID: '',
      error: {show: false, message: ''}
    },
    xpayUpdated: []
  }),
  computed: {
    ...mapGetters([
      vuexTypes.userTaurus,
      vuexTypes.userUplataInsha,
      vuexTypes.userXpay
    ])
  },
  async created () {
    await this.updateObjects()
  },
  methods: {
    ...mapActions({
      updateTaurus: vuexTypes.SET_USER_TAURUS,
      getTaurus: vuexTypes.GET_USER_TAURUS,
      updateUplataInsha: vuexTypes.SET_USER_UPLATA_INSHA,
      deleteUplataInsha: vuexTypes.DELETE_USER_UPLATA_INSHA,
      getUplataInsha: vuexTypes.GET_USER_UPLATA_INSHA,
      getXpay: vuexTypes.GET_USER_XPAY,
      updateXpay: vuexTypes.SET_USER_XPAY
    }),
    async updateObjects (activeItem = 0) {
      await this.getXpay()
      this.xpayUpdated = []
      for (const i in this.userXpay) {
        const xpay = this.userXpay[i]
        if (xpay.pi_type_id !== XPAY_NON_VISIBLE_TYPE) this.xpayUpdated.push({id: i18n.withdraw_xpay({name: xpay.name, mask_pan: xpay.mask_pan}), auto: false})
      }
      this.form.newID = ''
      this.isUpdated = false
      this.isReadyToAdd = false
      this.isDisabled = this.xpayUpdated.length === 0
      if (this.isDisabled) {
        this.form.idx = -2
        this.form.error = {show: true, message: i18n.lbl_add_uplata_insha()}
      } else {
        this.form.idx = activeItem
        this.form.error = {show: false, message: ''}
      }
    },
    async newXpayUpdated () {
      try {
        const data = await this.updateXpay()
        const myWidth = window.innerWidth
        const myHeight = window.innerHeight
        const left = ((myWidth / 2) - (464 / 2))
        const top = ((myHeight / 2) - (512 / 2))
        this.popupWindow = window.open(data.URI, '_blank', 'left=' + left + ',top=' + top + ',width=464,height=512,location=no,status=no,toolbar=no,menubar=no,resizable=yes,scrollbars=yes')
      } catch (error) {
        console.log('ERROR', error)
      }
    },
    async onAutoWithdraw () {
      // check autowithdraw is enabled on another Uplata Insha cards
      if (!this.xpayUpdated[this.form.idx].auto) {
        let idx = -2
        for (let i = 0; i < this.xpayUpdated.length; i++) {
          if (i !== this.form.idx && (this.xpayUpdated[i].auto || this.userXpay[i].auto)) {
            idx = i
            break
          }
        }
      // check autowithdraw is enabled on another Taurus card
        if (idx === -1) {
          await this.getTaurus()
          for (let i = 0; i < this.userTaurus.length; i++) {
            if (this.userTaurus[i].auto) {
              const opts = {
                message: i18n.set_confirm_autowithdraw_change({name: 'UPLATA', id: this.userTaurus[i].id})
              }
              if (!await confirmAction(opts)) return
              await this.unmarkTaurus(i)
              return
            }
          }
        } else {
          const opts = {
            message: i18n.set_confirm_autowithdraw_change({ name: i18n.lbl_uplata_insha_name(), id: this.xpayUpdated[idx].id })
          }
          if (!await confirmAction(opts)) return
          this.xpayUpdated[idx].auto = false
        }
      }
      this.xpayUpdated[this.form.idx].auto = !this.xpayUpdated[this.form.idx].auto
      let i = 0
      for (; i < this.xpayUpdated.length; i++) {
        const id = this.xpayUpdated[i].id
        const auto = this.xpayUpdated[i].auto
        if (this.userXpay.filter(card =>
          card.id === id && card.auto === auto).length === 0) break
      }
      this.isUpdated = i < this.xpayUpdated.length
    },
    async unmarkTaurus (idx) {
      this.disable()
      try {
        this.userTaurus[idx].auto = false
        await this.updateTaurus(this.userTaurus)
        this.xpayUpdated[this.form.idx].auto = true
        await this.updateUplataInsha(this.xpayUpdated)
        this.isUpdated = false
        this.updateObjects(this.form.idx)
        EventDispatcher.dispatchShowSuccessEvent(i18n.set_cards_changed())
      } catch (error) {
        const err = (await error).message
        console.error(err)
        if (error.showBanner) {
          error.showBanner(i18n.unexpected_error())
        } else {
          EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error() + ': ' + err)
        }
        this.xpayUpdated[this.form.idx].auto = false
      }
      this.enable()
    },
    async onDelete () {
      const uplata = this.xpayUpdated[this.form.idx]
      const opts = {
        title: i18n.lbl_delete_confirm_title(),
        message: i18n.lbl_id_delete_confirm(uplata),
        confirmText: i18n.lbl_delete()
      }
      if (!await confirmAction(opts)) return

      this.disable()
      if (await this.deleteUplataInsha(uplata)
          .then(_ => {
            return true
          }).catch(error => {
            console.error(error)
            if (error.showBanner) {
              error.showBanner(i18n.unexpected_error())
            } else {
              EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error() + ': ' + error.message)
            }
            return false
          })
      ) {
        this.updateObjects()
        EventDispatcher.dispatchShowSuccessEvent(i18n.set_uplata_insha_deleted())
      }
      this.enable()
    },
    async submit () {
      const xpay = this.isReadyToAdd ? {id: this.form.newID, auto: false} : this.xpayUpdated
      const opts = {
        message: this.isReadyToAdd ? i18n.lbl_id_add_confirm(xpay) : i18n.lbl_autowithdraw_confirm(),
        confirmText: this.isReadyToAdd ? i18n.lbl_add() : ''
      }
      if (!await confirmAction(opts)) return
      this.disable()
      if (await this.updateXpay(xpay)
          .then(_ => {
            return true
          }).catch(error => {
            console.error(error)
            if (error.showBanner) {
              error.showBanner(i18n.unexpected_error())
            } else {
              EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error() + ': ' + error.message)
            }
            return false
          })
      ) {
        console.log('UPDATE: ', this.isReadyToAdd ? this.userXpay.length - 1 : this.form.idx)
        // this.updateObjects(this.isReadyToAdd ? this.userXpay.length - 1 : this.form.idx)
        // EventDispatcher.dispatchShowSuccessEvent(this.isReadyToAdd ? i18n.set_uplata_insha_added() : i18n.set_uplata_insha_changed())
      }
      this.enable()
    }
  },
  watch: {
    isFormOpened () {
      this.updateObjects()
    },
    'form.newID' (value) {
      this.newXpayUpdated(value)
    },
    'form.idx' (value) {
      if (value === -1) {
        this.newXpayUpdated(this.form.newID)
      } else {
        this.isReadyToAdd = false
        this.form.error = {show: false, message: ''}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './settings.scss';

  .fa-plus:before{
    content:"\f067"
  }
  .md-dialog {
    width: 36rem;
  }
  .md-select-clear-selection {
    margin-top: 0.2rem;
    margin-right: 1rem;
    padding: 0;
  }
  .auto-withdraw, .delete-uplata {
    min-width: 7rem;
    margin-top: 0.2rem;
    margin-bottom: 0;
  }
  .label-select__actions {
    color: $col-text-secondary;
    font-size: 14px;
    margin-bottom: -1rem;
    float: right;
  }
  .label-select__caption {
    margin-left: 1rem;
  }
  .md-list-item-text * {
    width: 100%;
    margin: 0;
    overflow: hidden;
    line-height: 1.8em;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/settings/security/Security.Xpay.vue